import * as React from 'react';

import { BackgroundColorConfig } from './types';

export const BackgroundColorContext = React.createContext<{
  setBackgroundColorConfig: (config: BackgroundColorConfig) => void;
}>({
  setBackgroundColorConfig: () => undefined,
});
